import divisi from "../views/divisi/index.vue";
import divisi_create from "../views/divisi/create.vue";
import divisi_edit from "../views/divisi/edit.vue";
import divisi_detail from "../views/divisi/detail.vue";
import divisi_import from "../views/divisi/import.vue";

const routes = [
  {
    path: "/divisi",
    name: "divisi",
    component: divisi,
    meta: { authOnly: true }
  },
  {
    path: "/divisi/create",
    name: "divisi_create",
    component: divisi_create,
    meta: { authOnly: true }
  },
  {
    path: "/divisi/edit/:uuid",
    name: "divisi_edit",
    component: divisi_edit,
    meta: { authOnly: true }
  },
  {
    path: "/divisi/detail/:uuid",
    name: "divisi_detail",
    component: divisi_detail,
    meta: { authOnly: true }
  },
  {
    path: "/divisi/import",
    name: "divisi_import",
    component: divisi_import,
    meta: { authOnly: true }
  }
];

export default routes;
